// extracted by mini-css-extract-plugin
export default {"container":"JXHud","row":"_3WUP-","container-dark-bg-color":"E6U+a","containerDarkBgColor":"E6U+a"};